var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.59 50.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.84,0c-6.51,0-11.17,3.24-13.55,5.39-2.38-2.15-7.03-5.39-13.54-5.39C7.8,0,0,7.24,0,16.48c0,6.85,5.15,14.58,15.3,22.98,7.05,5.83,14.08,9.93,14.87,10.37.34.19.73.3,1.13.3s.78-.1,1.12-.29c.31-.18,7.72-4.39,14.87-10.27,10.15-8.35,15.3-16.12,15.3-23.09C62.59,7.24,54.79,0,44.84,0ZM31.29,19.88c-.75-.84-1.49-2.8-1.43-4.5.05-1.5.74-2.82,1.43-3.78.7.96,1.39,2.27,1.43,3.78.05,1.7-.69,3.66-1.43,4.5ZM25.67,15.25c-.08,2.72,1.04,5.92,2.68,7.61,1.77,1.82,4.13,1.82,5.9,0,1.64-1.69,2.76-4.89,2.68-7.61-.07-2.34-1.02-4.67-2.74-6.77,1.9-1.77,5.57-4.37,10.66-4.37,8.37,0,13.38,6.29,13.38,12.36,0,12.44-23.13,26.88-26.92,29.16-3.78-2.31-26.93-16.95-26.93-29.16,0-6.08,5-12.36,13.38-12.36,5.09,0,8.75,2.6,10.65,4.37-1.72,2.09-2.66,4.42-2.73,6.76Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.7ef68d1b80e2914e83995cfcb343d0c9.svg";
export { ForwardRef as ReactComponent };